import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApi, BaseService, EmptySerializer } from 'src/app/main';
import { DataConfiguration } from 'src/app/main/models/trip/data-configuration';

@Injectable({
    providedIn: 'root'
})
export class DataConfigurationService {

    private api: BaseApi;

    constructor(
        base: BaseService
    ) {
        this.api = base.setApi('gateway', 'core');///CustomerAuth
    }

    public getGratuityDiscountTypes(): Observable<{ GratuityDiscountTypes: string }> {
        return this.api.get('DataConfiguration/GetByKey?key=GratuityDiscountTypes', new EmptySerializer());
    }

    public getMercadoPagoCNPJAlphanumValidation(): Observable<{ MercadoPagoCNPJAlphanumValidation: boolean }> {
        return this.api.get<{ MercadoPagoCNPJAlphanumValidation: string }>(
            'DataConfiguration/GetByKey?key=MercadoPagoCNPJAlphanumValidation',
            new EmptySerializer()
        ).pipe(
            map(({ MercadoPagoCNPJAlphanumValidation }) => ({
                MercadoPagoCNPJAlphanumValidation: MercadoPagoCNPJAlphanumValidation?.toLowerCase() === 'true'
            }))
        );
    }
}